export default __webpack_public_path__ + "static/media/blissful-bell.0e5cc599.wav";